<template>
  <Card
    class="text-center flex flex-col gap-4"
    v-if="!frames || frames?.length"
  >
    <h1 class="text-lg font-bold tracking-wide">Avatar Frames</h1>
    <slot name="description" v-if="description || $slots.description">
      <p>{{ description }}</p>
    </slot>

    <div
      v-if="frames"
      class="mt-auto group overflow-hidden rounded-lg aspect-video select-none flex items-center justify-center gap-4"
      :class="{
        subscribe: subscribeLink,
        'stage-gradient-nami': !subscribeLink,
        'stage-gradient-yellow': subscribeLink,
      }"
      role="button"
      @click="showAll = true"
    >
      <FrameImage
        v-for="frame in frames"
        :frame="frame"
        class="w-[35%] aspect-1/1 pointer-events-none h-auto bg-neutral-800/70 rounded-full"
      />
    </div>
    <Skeleton v-else class="aspect-video" />
    <NamiModal v-model="showAll" large>
      <NamiModalTitle @close="showAll = false">All Frames</NamiModalTitle>
      <div class="grid grid-cols-6 gap-4">
        <FrameImage
          v-for="frame in frames"
          :frame="frame"
          class="w-auto h-auto aspect-1/1 m-auto"
        />
      </div>
    </NamiModal>
  </Card>
</template>

<script setup lang="ts">
import type { FrameEntity } from "~/src/api";

defineProps<{
  frames?: FrameEntity[] | false | null;
  subscribeLink?: string;
  description?: string;
}>();

const showAll = ref(false);
</script>
